import { post, get } from "../common/dataFetch";
import { GovernmentQuestion } from "../store/GovernmentQuestionStore";

export const getGovernmentQuestion = (borrowerType: string,interimLoanStagingId:number) => {
    return get<GovernmentQuestion>(`GovernmentQuestion/ReadByInterimIdAsync?borrowerType=${borrowerType}&interimLoanStagingId=${interimLoanStagingId}`);
};
export const updateGovernmentQuestion = (govermentQuestionDto: GovernmentQuestion) => {
    return post<any>("GovernmentQuestion/UpsertAsync", govermentQuestionDto);
};
